import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TrayConfig, TrayCommand } from './tray.model';

@Injectable({
  providedIn: 'root'
})
export class TrayService {

  public command: BehaviorSubject<TrayCommand> = new BehaviorSubject<TrayCommand>(null);
  public tray: TrayConfig | undefined;
  public trays: Record<string, TrayConfig> = {};

  /** Deferred FM dynamic field saves keyed by RequestFulfillmentCustomers id (issue #10681). */
  private pendingFulfillmentDynamicFieldSaves = new Map<string, () => Promise<unknown>>();

  constructor() { }

  registerPendingFulfillmentDynamicFieldSave(memberId: string, saveFn: () => Promise<unknown>): void {
    this.pendingFulfillmentDynamicFieldSaves.set(memberId, saveFn);
  }

  async flushPendingFulfillmentDynamicFieldSaves(): Promise<void> {
    const saves = [...this.pendingFulfillmentDynamicFieldSaves.values()];
    this.pendingFulfillmentDynamicFieldSaves.clear();
    await Promise.all(saves.map(fn => fn()));
  }
  
  public clearAll() {
    this.command.next({ clearAll: true });
  }

  public getTray(id: string): TrayConfig | undefined {
    return this.trays[id];
  }

  public register(tray: TrayConfig) {
    this.trays[tray.id] = tray;
  }

  public requestTray(trayId: string, objects?: any): TrayConfig {
    this.command.next({ requestTray: trayId, objects });
    this.trays[trayId] = { id: trayId, data: { ...objects } };
    return this.trays[trayId];
  }

  public toggleTray(tray: TrayConfig) {
    if (!tray?.id) { return; }
    this.tray = tray;
    this.trays[tray.id] = tray;
    this.command.next({ toggleTray: tray });
  }

  public toggleInnerTray(tray: TrayConfig) {
    if (!tray?.id) { return; }
    this.tray = tray;
    this.trays[tray.id] = tray;
    this.command.next({ toggleInnerTray: tray });
  }

  public closeTray() {
    this.command.next({ closeTray: true, tray: this.tray });
  }

  public closeInnerTray(tray: TrayConfig | string) {
    this.command.next({ closeInnerTray: tray });
  }

  public triggerFilter() {
    this.command.next({ triggerFilter: true });
  }

  public sendMessage(msg: any) {
    this.command.next({ msg });
  }
}

